import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  required: {
    id: 'd/qpWD',
    defaultMessage: '(required)',
    description: 'Annotation text for template attributes that are required',
  },
});
